// src/utils/auth.js

// Store user data in localStorage
export const setAuthData = (data) => {
  localStorage.setItem('token', data.token);
  localStorage.setItem('role', data.role);
  localStorage.setItem('userId', data.userId);
  localStorage.setItem('schoolId', data.schoolId);
  localStorage.setItem('fullName', data.fullName);
};

// Get user data from localStorage
export const getAuthData = () => {
  return {
    token: localStorage.getItem('token'),
    role: localStorage.getItem('role'),
    userId: localStorage.getItem('userId'),
    schoolId: localStorage.getItem('schoolId'),
    fullName: localStorage.getItem('fullName')
  };
};

// Clear auth data
export const clearAuthData = () => {
  localStorage.removeItem('token');
  localStorage.removeItem('role');
  localStorage.removeItem('userId');
  localStorage.removeItem('schoolId');
  localStorage.removeItem('fullName');
};

// Check if user is authenticated
export const isAuthenticated = () => {
  return !!localStorage.getItem('token');
};

// Get user role
export const getUserRole = () => {
  return localStorage.getItem('role');
};

// Check if token is expired (basic check)
export const isTokenExpired = () => {
  const token = localStorage.getItem('token');
  if (!token) return true;

  try {
    const payload = JSON.parse(atob(token.split('.')[1]));
    const exp = payload.exp * 1000; // Convert to milliseconds
    return Date.now() >= exp;
  } catch (error) {
    return true;
  }
};

// Format date helper
export const formatDate = (dateString) => {
  if (!dateString) return 'N/A';
  const date = new Date(dateString);
  return date.toLocaleDateString('en-IN', {
    year: 'numeric',
    month: 'short',
    day: 'numeric'
  });
};

// Format currency
export const formatCurrency = (amount) => {
  if (!amount && amount !== 0) return '₹0';
  return `₹${parseFloat(amount).toLocaleString('en-IN')}`;
};

// Validate email
export const isValidEmail = (email) => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};

// Validate phone number (Indian)
export const isValidPhone = (phone) => {
  const phoneRegex = /^[6-9]\d{9}$/;
  return phoneRegex.test(phone);
};

export default {
  setAuthData,
  getAuthData,
  clearAuthData,
  isAuthenticated,
  getUserRole,
  isTokenExpired,
  formatDate,
  formatCurrency,
  isValidEmail,
  isValidPhone
};